import { parse, isPast } from "date-fns";

const promocaoEncerrada = parse(process.env.REACT_APP_END_PROMO, "dd/MM/yyyy", new Date());

const promoHasEnded = () => {
  const today = new Date();
  return isPast(promocaoEncerrada, today);
};

export default promoHasEnded;